// extracted by mini-css-extract-plugin
export var divider = "_ya-0";